import { useRef } from 'react';

export const useScrollRestore = () => {
    const scrollYRef = useRef<number>(0);
    const shouldRestoreRef = useRef(false);

    const saveScrollPosition = () => {
        scrollYRef.current = window.scrollY;
        shouldRestoreRef.current = true;
    };

    const restoreScrollPosition = () => {
        if (!shouldRestoreRef.current) return;

        requestAnimationFrame(() => {
            window.scrollTo({
                top: scrollYRef.current,
                behavior: 'auto',
            });
            shouldRestoreRef.current = false;
        });
    };

    return {
        saveScrollPosition,
        restoreScrollPosition,
    };
};
